import { useCallback } from 'react';

import { CONFIRM_POPUP_MODE, useConfirmPopup } from 'src/components/ConfirmPopup';
import { SUGGESTED_AUDIENCES } from 'src/lib/events';
import { useErrorHandler } from 'src/services/useErrorHandler';
import { PAGES, SUB_PAGES, useTrackingEvent } from 'src/services/useTrackingEvent';
import { useCustomerActions, useCustomerPersonaActions, useNotificationActions } from 'src/store';

export const useDeleteCustomerPersona = () => {
  const confirmPopup = useConfirmPopup();
  const customerActions = useCustomerActions();
  const customerPersonaStoreActions = useCustomerPersonaActions();
  const notificationActions = useNotificationActions();
  const handleError = useErrorHandler();
  const trackingEvent = useTrackingEvent();

  return useCallback(
    (customerPersona) =>
      new Promise((resolve) => {
        const onConfirm = () => {
          customerPersonaStoreActions
            .deleteCustomerPersona(customerPersona.id)
            .then(() => {
              notificationActions.displaySuccess(
                `Target audience '${customerPersona.name}' deleted`
              );
              if (customerPersona.isSuggested) {
                trackingEvent(SUGGESTED_AUDIENCES.deleted, {
                  page: PAGES.editor,
                  subPage: SUB_PAGES.generationPanel,
                });
              }
              resolve(true);
              customerActions.refreshCurrentCustomerFeatureLimit();
            })
            .catch((error) => {
              handleError(error);
              resolve(false);
            });
        };

        const onCancel = () => {
          resolve(false);
        };

        // TODO - align this popup with all other brand voice popups
        confirmPopup({
          mode: CONFIRM_POPUP_MODE.warning,
          title: `Delete this target audience?`,
          content: 'This action cannot be undone.',
          buttons: {
            confirm: 'Delete',
            cancel: 'Cancel',
          },
          onConfirm,
          onCancel,
        });
      }),
    [
      confirmPopup,
      customerPersonaStoreActions,
      notificationActions,
      customerActions,
      trackingEvent,
      handleError,
    ]
  );
};
